import { useEffect } from "react";
import Smartlook from "smartlook-client";
import { useUserDetails } from "./useSupervisorDetails";

const useSmartlook = () => {
  const userDetails = useUserDetails();

  useEffect(() => {
    if (typeof window !== "undefined") {
      Smartlook.init(import.meta.env.VITE_SMARTLOOK_KEY, { region: "eu" });
    }

    if (userDetails) {
      const userInfo = {
        id: userDetails.id as string,
        email: userDetails.email as string,
        name: userDetails.name as string,
      };
      Smartlook.identify(userDetails.email as string, userInfo);
    }
  }, [userDetails]); // Depend on currentUser to re-run this effect when it changes

  return null; // Since it doesn't render anything, return null
};

export default useSmartlook;
